(function () {
  if (window.MKDialogDiagnosticCustomizer) return;
  window.MKDialogDiagnosticCustomizer = true;

  var config = window.MKDialogDiagnosticConfig || {};
  var LOGO_URL = config.logoUrl || 'https://cdn.shopify.com/s/files/1/0810/8218/8110/files/sigle_seul_MK_noir.svg?v=1736171017';
  var LOGO_WIDTH = config.logoWidth || 72;
  var PLANITY_URL = config.planityUrl || 'https://www.planity.com/maison-kosane';
  var TITLE = 'Assistant maison kōsane';
  var QUESTION_TEXT = 'Prendre rdv en boutique';

  var panelObserver = null;
  var customizeQueued = false;
  var panelRefreshQueued = false;
  var activeMode = 'default';
  var productSubtitleCache = new Map();

  function addClasses(element, className) {
    if (!element) return;
    className.split(' ').forEach(function (item) {
      if (item && !element.classList.contains(item)) element.classList.add(item);
    });
  }

  function removeClasses(element, className) {
    if (!element) return;
    className.split(' ').forEach(function (item) {
      if (item && element.classList.contains(item)) element.classList.remove(item);
    });
  }

  function setAttributeIfChanged(element, name, value) {
    if (!element || element.getAttribute(name) === value) return;
    element.setAttribute(name, value);
  }

  function getPanel() {
    return document.getElementById('dialog-ai-chat-panel');
  }

  function markPanelShell(panel) {
    if (!panel) return;

    var shell = panel.parentElement;
    var depth = 0;
    while (shell && shell !== document.body && depth < 2) {
      setAttributeIfChanged(shell, 'data-mk-dialog-shell', 'true');
      shell = shell.parentElement;
      depth += 1;
    }
  }

  function panelSnapshot(reason) {
    var panel = getPanel();
    if (!panel) {
      return {
        reason: reason,
        panelFound: false
      };
    }

    return {
      reason: reason,
      panelFound: true,
      textLength: panel.textContent.trim().length,
      buttons: panel.querySelectorAll('button').length,
      spans: panel.querySelectorAll('span').length,
      svgs: panel.querySelectorAll('svg').length,
      imgs: panel.querySelectorAll('img').length,
      hasDiagnosticChoices: Boolean(findWithoutPhotoButton(panel)),
      hasInput: Boolean(panel.querySelector('#dialog-ai-input')),
      textSample: panel.textContent.trim().replace(/\s+/g, ' ').slice(0, 180)
    };
  }

  function findWithoutPhotoButton(container) {
    var direct = container.querySelector(
      '.dialog-diagnostic-choice-without-photo, [data-dialog-choice="without-photo"]'
    );
    if (direct) return direct;

    var buttons = Array.prototype.slice.call(container.querySelectorAll('button'));
    return buttons.find(function (button) {
      return /répondre à quelques questions|repondre a quelques questions|answer a few questions|sans photo|without photo/i.test(button.textContent.trim());
    }) || null;
  }

  function isPanelHydrated(panel, mode) {
    if (!panel) return false;

    var textLength = panel.textContent.trim().length;
    var buttonCount = panel.querySelectorAll('button').length;

    if (mode === 'diagnostic') {
      return textLength > 20 && buttonCount >= 3 && Boolean(findWithoutPhotoButton(panel));
    }

    return textLength > 10 || buttonCount > 0 || Boolean(panel.querySelector('#dialog-ai-input'));
  }

  function syncSingleLogo(container) {
    markPanelShell(container);

    var nativeLogos = Array.prototype.filter.call(
      container.querySelectorAll('svg[viewBox="0 0 32 31"]'),
      function (logo) { return !logo.closest('a[href*="askdialog.com"]'); }
    );

    function createLogo(context) {
      var image = document.createElement('img');
      image.src = LOGO_URL;
      image.alt = 'Maison Kosane';
      image.width = LOGO_WIDTH;
      image.loading = 'eager';
      setAttributeIfChanged(image, 'data-mk-dialog-logo', 'true');
      setAttributeIfChanged(image, 'data-mk-dialog-logo-context', context);
      return image;
    }

    nativeLogos.forEach(function (nativeLogo) {
      var host = nativeLogo.parentElement;
      if (!host) return;
      var existing = host.querySelector(':scope > [data-mk-dialog-logo]');
      if (existing) {
        nativeLogo.remove();
        return;
      }
      nativeLogo.replaceWith(createLogo('loading'));
    });

    container.querySelectorAll('span').forEach(function (title) {
      if (!/^assistant(?: maison kōsane)?$/i.test(title.textContent.trim())) return;

      var titleRow = title.parentElement;
      var logoRegion = title.previousElementSibling;
      if (!titleRow || !logoRegion) return;

      var isSticky = Boolean(
        titleRow.nextElementSibling && titleRow.nextElementSibling.querySelector('button[aria-label="Fermer"]')
      );
      var context = isSticky ? 'sticky' : 'initial';
      var host = logoRegion;

      while (host.children.length === 1 && host.firstElementChild && host.firstElementChild.tagName === 'DIV') {
        host = host.firstElementChild;
      }

      var logo = logoRegion.querySelector('[data-mk-dialog-logo]');
      if (!logo) {
        logo = createLogo(context);
        host.replaceChildren(logo);
      }

      setAttributeIfChanged(logo, 'data-mk-dialog-logo-context', context);
      setAttributeIfChanged(logoRegion, 'data-mk-dialog-logo-region', context);
      setAttributeIfChanged(titleRow, 'data-mk-dialog-title-row', context);
    });

    container.querySelectorAll('[data-mk-dialog-logo]').forEach(function (logo) {
      var wrapper = logo.parentElement;
      if (wrapper) setAttributeIfChanged(wrapper, 'data-mk-dialog-logo-chrome', 'true');
    });
  }

  function updateAssistantTitles(container) {
    container.querySelectorAll('span').forEach(function (span) {
      if (span.textContent.trim() !== 'Assistant') return;
      setAttributeIfChanged(span, 'data-mk-dialog-original-text', span.textContent);
      span.textContent = TITLE;
      addClasses(span, 'title lg');
      setAttributeIfChanged(span, 'data-mk-dialog-title', 'true');
    });
  }

  function updateTopControls(container) {
    container.querySelectorAll('button[aria-label="Info"], button[aria-label="Fermer"]').forEach(function (button) {
      setAttributeIfChanged(button, 'data-mk-dialog-top-control', 'true');
    });

    var closeButton = container.querySelector('button[aria-label="Fermer"]');
    var controlsGroup = closeButton && closeButton.parentElement;
    if (controlsGroup) setAttributeIfChanged(controlsGroup, 'data-mk-dialog-top-controls-group', 'true');

    var titleRow = container.querySelector('[data-mk-dialog-title-row]');
    var resolvedTopBar = null;
    if (!titleRow) {
      var assistantTitle = Array.prototype.slice.call(container.querySelectorAll('span')).find(function (span) {
        return /^assistant(?: maison kōsane)?$/i.test(span.textContent.trim());
      });
      titleRow = assistantTitle && assistantTitle.parentElement;
      if (titleRow) setAttributeIfChanged(titleRow, 'data-mk-dialog-title-row', 'initial');
    }
    if (titleRow && controlsGroup) {
      var topBar = titleRow;
      while (topBar && topBar !== container && !topBar.contains(controlsGroup)) {
        topBar = topBar.parentElement;
      }
      if (topBar && topBar !== container) {
        resolvedTopBar = topBar;
        setAttributeIfChanged(topBar, 'data-mk-dialog-top-bar', 'true');
        setAttributeIfChanged(topBar, 'data-mk-dialog-top-bar-state', 'initial');
      }
    }
    if (!container.querySelector('[data-mk-dialog-top-bar]') && controlsGroup && controlsGroup.parentElement && controlsGroup.parentElement !== container) {
      resolvedTopBar = controlsGroup.parentElement;
      setAttributeIfChanged(resolvedTopBar, 'data-mk-dialog-top-bar', 'true');
      setAttributeIfChanged(resolvedTopBar, 'data-mk-dialog-top-bar-state', 'initial');
    }
    resolvedTopBar = resolvedTopBar || container.querySelector('[data-mk-dialog-top-bar]');
    if (!titleRow && resolvedTopBar && controlsGroup) {
      titleRow = Array.prototype.slice.call(resolvedTopBar.children).find(function (child) {
        return child !== controlsGroup && (
          /assistant/i.test(child.textContent || '') ||
          Boolean(child.querySelector('[data-mk-dialog-logo], img, svg'))
        );
      });
      if (titleRow) setAttributeIfChanged(titleRow, 'data-mk-dialog-title-row', 'initial');
    }

    var closeTemplate = document.getElementById('mk-dialog-close-icon-template');
    if (closeButton && closeTemplate && !closeButton.querySelector('[data-mk-dialog-close-icon]')) {
      closeButton.innerHTML = closeTemplate.innerHTML;
      var closeIcon = closeButton.querySelector('svg');
      if (closeIcon) setAttributeIfChanged(closeIcon, 'data-mk-dialog-close-icon', 'true');
    }

    syncDialogTopBarState(container);
  }

  function syncDialogTopBarState(container) {
    if (!container) return;
    var topBar = container.querySelector('[data-mk-dialog-top-bar]');
    if (!topBar) return;

    var scrollContainer = container.querySelector('[data-mk-dialog-chat-scroll-container]');
    var isSticky = Boolean(scrollContainer && scrollContainer.scrollTop > 1);
    setAttributeIfChanged(topBar, 'data-mk-dialog-top-bar-state', isSticky ? 'sticky' : 'initial');

    [topBar, topBar.querySelector('[data-mk-dialog-title-row]'), topBar.querySelector('[data-mk-dialog-top-controls-group]')].forEach(function (element) {
      if (!element) return;
      if (isSticky) {
        element.style.setProperty('background', '#ffffff', 'important');
        element.style.setProperty('background-color', '#ffffff', 'important');
        return;
      }
      element.style.removeProperty('background');
      element.style.removeProperty('background-color');
    });
  }

  function bindDialogTopBarState(container) {
    if (!container || container.hasAttribute('data-mk-dialog-top-bar-bound')) return;
    var scrollContainer = container.querySelector('[data-mk-dialog-chat-scroll-container]');
    if (!scrollContainer) return;
    setAttributeIfChanged(container, 'data-mk-dialog-top-bar-bound', 'true');

    var scheduled = false;
    scrollContainer.addEventListener('scroll', function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncDialogTopBarState(container);
      });
    }, { passive: true });
  }

  function styleTextNodes(container) {
    container.querySelectorAll('pre, button, textarea, span:not([data-mk-dialog-title]), a').forEach(function (element) {
      if (element.hasAttribute('data-mk-dialog-text-ready')) return;
      addClasses(element, 'text sm medium');
      setAttributeIfChanged(element, 'data-mk-dialog-text-ready', 'true');
    });
  }

  function styleButtons(container) {
    container.querySelectorAll('button').forEach(function (button) {
      if (button.matches('[aria-label="Info"], [aria-label="Fermer"]')) return;

      addClasses(button, 'text mk-btn-frame mk-btn-frame--sm mk-btn-frame--black');
      removeClasses(button, 'mk-btn-primary mk-btn-primary--sm mk-btn-primary--burgundy bg-burgundy rose-sand border-burgundy');
      setAttributeIfChanged(button, 'data-mk-dialog-button-ready', 'true');

      if (button.matches('.dialog-diagnostic-choice-take-photo, .dialog-diagnostic-choice-import-photo, .dialog-diagnostic-choice-without-photo, [data-mk-planity-choice]')) {
        setAttributeIfChanged(button, 'data-mk-dialog-spark-button', 'true');
      }
    });
  }

  function resetDiagnosticCustomization(container) {
    container.querySelectorAll('[data-mk-planity-choice]').forEach(function (button) {
      button.remove();
    });

    container.querySelectorAll('[data-mk-dialog-title]').forEach(function (title) {
      var originalText = title.getAttribute('data-mk-dialog-original-text');
      if (originalText !== null) title.textContent = originalText;
      removeClasses(title, 'title lg');
      title.removeAttribute('data-mk-dialog-title');
      title.removeAttribute('data-mk-dialog-original-text');
    });

    container.querySelectorAll('[data-mk-dialog-text-ready]').forEach(function (element) {
      removeClasses(element, 'text sm medium');
      element.removeAttribute('data-mk-dialog-text-ready');
    });

    container.querySelectorAll('[data-mk-dialog-button-ready]').forEach(function (button) {
      removeClasses(button, 'text mk-btn-frame mk-btn-frame--sm mk-btn-frame--black');
      button.removeAttribute('data-mk-dialog-button-ready');
      button.removeAttribute('data-mk-dialog-spark-button');
    });
  }

  function addPlanityChoice(container) {
    var withoutPhotoButton = findWithoutPhotoButton(container);
    if (!withoutPhotoButton || container.querySelector('[data-mk-planity-choice]')) return;
    var hasIcon = Boolean(withoutPhotoButton.querySelector('svg'));

    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = QUESTION_TEXT;
    button.className = withoutPhotoButton.className;
    addClasses(button, 'text sm medium mk-btn-frame mk-btn-frame--sm mk-btn-frame--black');
    setAttributeIfChanged(button, 'data-mk-planity-choice', 'true');
    setAttributeIfChanged(button, 'data-mk-dialog-spark-button', 'true');
    if (hasIcon) {
      var iconTemplate = document.getElementById('mk-dialog-spark-icon-template');
      if (iconTemplate) button.insertAdjacentHTML('afterbegin', iconTemplate.innerHTML);
    }
    button.addEventListener('click', function () {
      window.location.href = PLANITY_URL;
    });

    withoutPhotoButton.insertAdjacentElement('afterend', button);
  }

  function createNativePlanityChoice(referenceButton) {
    if (!referenceButton) return null;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = referenceButton.className;
    button.textContent = QUESTION_TEXT;
    setAttributeIfChanged(button, 'data-mk-planity-choice', 'true');
    setAttributeIfChanged(button, 'data-mk-dialog-spark-button', 'true');

    var referenceIcon = referenceButton.querySelector('svg');
    var iconTemplate = document.getElementById('mk-dialog-spark-icon-template');
    if (referenceIcon && iconTemplate) button.insertAdjacentHTML('afterbegin', iconTemplate.innerHTML);

    return button;
  }

  function enhanceDiagnosticChoices(container) {
    var selector = [
      '.dialog-diagnostic-choice-take-photo',
      '.dialog-diagnostic-choice-import-photo',
      '.dialog-diagnostic-choice-without-photo',
      '[data-mk-planity-choice]'
    ].join(', ');
    var buttons = Array.prototype.slice.call(container.querySelectorAll(selector));
    var iconTemplate = document.getElementById('mk-dialog-spark-icon-template');

    buttons.forEach(function (button) {
      var currentIcon = button.querySelector('svg');
      if (!currentIcon || !iconTemplate || currentIcon.classList.contains('icon-dialog-spark')) return;
      currentIcon.outerHTML = iconTemplate.innerHTML;
    });

    if (!buttons.length) return;
    var buttonContainer = buttons[0].parentElement;
    while (buttonContainer && buttonContainer !== container) {
      if (buttons.every(function (button) { return buttonContainer.contains(button); })) break;
      buttonContainer = buttonContainer.parentElement;
    }
    if (buttonContainer && buttonContainer !== container) {
      setAttributeIfChanged(buttonContainer, 'data-mk-dialog-diagnostic-choices', 'true');
      if (buttonContainer.parentElement) {
        setAttributeIfChanged(buttonContainer.parentElement, 'data-mk-dialog-diagnostic-stage', 'true');
      }
    }

  }

  function hidePoweredBy(container) {
    container.querySelectorAll('a[href*="askdialog.com"]').forEach(function (poweredLink) {
      var poweredBy = poweredLink.closest('div');
      if (poweredBy && poweredBy.querySelector('#dialog-ai-input')) return;
      if (poweredBy) setAttributeIfChanged(poweredBy, 'data-mk-dialog-powered-by', 'hidden');
      setAttributeIfChanged(poweredLink, 'data-mk-dialog-powered-by-link', 'hidden');
    });

    container.querySelectorAll('div, span, p').forEach(function (element) {
      if (element.querySelector('#dialog-ai-input')) {
        element.removeAttribute('data-mk-dialog-powered-by');
        return;
      }
      var text = element.textContent.trim().replace(/\s+/g, ' ');
      if (!/^powered by\b/i.test(text) || text.length > 80) return;
      setAttributeIfChanged(element, 'data-mk-dialog-powered-by', 'hidden');
    });
  }

  function markChatMessages(container) {
    container.querySelectorAll('.dialog-message, .dialog-message pre, .dialog-message p, .dialog-human-message').forEach(function (message) {
      addClasses(message, 'text md');
      removeClasses(message, 'xs sm lg medium');
    });

    container.querySelectorAll('.dialog-human-message').forEach(function (message) {
      addClasses(message, 'bg-dark-grey');
    });
  }

  function getCommonAncestor(first, second, stopAt) {
    if (!first || !second) return stopAt || null;
    var ancestors = [];
    var current = first;
    while (current && current !== document.body) {
      ancestors.push(current);
      if (current === stopAt) break;
      current = current.parentElement;
    }

    current = second;
    while (current && current !== document.body) {
      if (ancestors.indexOf(current) !== -1) return current;
      if (current === stopAt) break;
      current = current.parentElement;
    }

    return stopAt || null;
  }

  function getBranchBelow(root, descendant, footer) {
    if (!root || !descendant) return null;
    var branch = null;
    var current = descendant.nodeType === 1 ? descendant : descendant.parentElement;

    while (current && current !== root) {
      if (
        current.tagName === 'DIV' &&
        current !== footer &&
        !(footer && current.contains(footer)) &&
        !current.closest('[data-mk-dialog-product-card]')
      ) {
        branch = current;
      }
      current = current.parentElement;
    }

    return branch;
  }

  function clearChatScrollMarks(container) {
    container.querySelectorAll(
      '[data-mk-dialog-chat-scroll-root], [data-mk-dialog-chat-scroll-chain], [data-mk-dialog-chat-scroll-container]'
    ).forEach(function (element) {
      element.removeAttribute('data-mk-dialog-chat-scroll-root');
      element.removeAttribute('data-mk-dialog-chat-scroll-chain');
      element.removeAttribute('data-mk-dialog-chat-scroll-container');
    });
  }

  function markChatScrollChain(root, target) {
    var current = target && target.parentElement;
    while (current && current !== root) {
      setAttributeIfChanged(current, 'data-mk-dialog-chat-scroll-chain', 'true');
      current = current.parentElement;
    }
  }

  function markChatScrollContainer(container, form) {
    if (!container || !form) return null;
    var footer = form.parentElement && form.parentElement.parentElement;
    var messages = Array.prototype.slice.call(container.querySelectorAll('.dialog-message, .dialog-human-message'));
    var message = messages[0] || form;
    var currentTarget = container.querySelector('[data-mk-dialog-chat-scroll-container]');
    var currentRoot = container.querySelector('[data-mk-dialog-chat-scroll-root]');

    if (
      currentTarget &&
      currentTarget.isConnected &&
      currentTarget.contains(message) &&
      !currentTarget.contains(form) &&
      !(footer && currentTarget.contains(footer))
    ) {
      return currentTarget;
    }

    var previousScrollTop = currentTarget ? currentTarget.scrollTop : 0;
    var previousWasNearBottom = currentTarget ? (
      currentTarget.scrollTop + currentTarget.clientHeight >= currentTarget.scrollHeight - 12
    ) : false;
    clearChatScrollMarks(container);

    var root = getCommonAncestor(message, footer || form, container);
    if (root === container && message !== form) {
      root = getCommonAncestor(message, form, container);
    }

    var target = getBranchBelow(root, message, footer);
    if (!target) {
      var candidates = Array.prototype.slice.call(container.querySelectorAll('div')).filter(function (element) {
        if (!element.contains(message)) return false;
        if (element === form || form.contains(element) || element.contains(form)) return false;
        if (footer && (element === footer || element.contains(footer))) return false;
        if (element.closest('[data-mk-dialog-product-card]')) return false;
        return element.getBoundingClientRect().height > 80;
      });

      candidates.sort(function (a, b) {
        var aHeight = a.getBoundingClientRect().height;
        var bHeight = b.getBoundingClientRect().height;
        return bHeight - aHeight;
      });

      target = candidates[0] || null;
    }

    if (root && root !== container) setAttributeIfChanged(root, 'data-mk-dialog-chat-scroll-root', 'true');
    if (target) {
      markChatScrollChain(root, target);
      setAttributeIfChanged(target, 'data-mk-dialog-chat-scroll-container', 'true');
      if (previousScrollTop > 0 || previousWasNearBottom) {
        window.requestAnimationFrame(function () {
          if (!target.isConnected) return;
          target.scrollTop = previousWasNearBottom
            ? target.scrollHeight
            : Math.min(previousScrollTop, Math.max(0, target.scrollHeight - target.clientHeight));
        });
      }
    }
    return target;
  }

  function markChatInput(container, forceVisible) {
    var input = container.querySelector('#dialog-ai-input');
    var form = input && input.closest('form');
    if (!input || !form) return;

    setAttributeIfChanged(form, 'data-mk-dialog-chat-form', 'true');
    if (form.parentElement) setAttributeIfChanged(form.parentElement, 'data-mk-dialog-chat-form-wrap', 'true');
    if (form.parentElement && form.parentElement.parentElement) {
      setAttributeIfChanged(form.parentElement.parentElement, 'data-mk-dialog-chat-footer', 'true');
    }
    var ancestor = form.parentElement;
    var depth = 0;
    while (ancestor && ancestor !== container && depth < 5) {
      ancestor.removeAttribute('data-mk-dialog-powered-by');
      ancestor.removeAttribute('data-mk-dialog-powered-by-link');
      setAttributeIfChanged(ancestor, 'data-mk-dialog-chat-input-ancestor', 'true');
      ancestor = ancestor.parentElement;
      depth += 1;
    }

    if (activeMode === 'chat' || forceVisible) {
      syncSingleLogo(container);
      updateTopControls(container);
      setAttributeIfChanged(container, 'data-mk-dialog-chat-input-visible', 'true');
      markChatScrollContainer(container, form);
      bindDialogTopBarState(container);
      syncDialogTopBarState(container);
    }
  }

  function normalizeProductTitle(value) {
    return (value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  }

  function fetchProductSubtitle(title) {
    var cacheKey = normalizeProductTitle(title);
    if (!cacheKey) return Promise.resolve('');
    if (productSubtitleCache.has(cacheKey)) return productSubtitleCache.get(cacheKey);

    var request = fetch('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=6', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search returned ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        var products = payload && payload.resources && payload.resources.results && payload.resources.results.products;
        var product = Array.isArray(products) && products.find(function (item) {
          return normalizeProductTitle(item.title) === cacheKey;
        });
        if (!product || !product.url) return '';
        return fetch(product.url, { headers: { Accept: 'text/html' } });
      })
      .then(function (response) {
        if (!response || !response.ok) return '';
        return response.text();
      })
      .then(function (html) {
        if (!html) return '';
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var subtitle = documentFragment.querySelector('.product-page-header__subtitle');
        return subtitle ? subtitle.textContent.trim().replace(/^\(|\)$/g, '').trim() : '';
      })
      .catch(function () {
        return '';
      });

    productSubtitleCache.set(cacheKey, request);
    return request;
  }

  function enrichRecommendationCard(card, titleElement, content) {
    if (!card || !titleElement || !content || card.hasAttribute('data-mk-dialog-subtitle-requested')) return;
    setAttributeIfChanged(card, 'data-mk-dialog-subtitle-requested', 'true');

    fetchProductSubtitle(titleElement.textContent).then(function (subtitle) {
      if (!subtitle || !card.isConnected || content.querySelector('[data-mk-dialog-product-subtitle]')) return;
      var subtitleElement = document.createElement('p');
      subtitleElement.textContent = '(' + subtitle + ')';
      subtitleElement.className = 'card-product__subtitle title xs light black';
      subtitleElement.setAttribute('data-mk-dialog-product-subtitle', 'true');
      content.insertBefore(subtitleElement, titleElement);
    });
  }

  function markRecommendationCards(container) {
    var messagesStart = container.querySelector(
      '#desktop-load-previous-messages-button-container, .dialog-human-message, .dialog-message'
    );
    if (!messagesStart) return;

    container.querySelectorAll('[class*="e1biv6t07"]').forEach(function (card) {
      var isBeforeMessages = messagesStart && Boolean(
        card.compareDocumentPosition(messagesStart) & Node.DOCUMENT_POSITION_FOLLOWING
      );

      setAttributeIfChanged(card, 'data-mk-dialog-product-card', isBeforeMessages ? 'sticky' : 'recommendation');
      if (isBeforeMessages) return;

      addClasses(card, 'card-product card-product__layout--standard card-product--dialog-recommendation');

      var cardLink = card.querySelector('[class*="e1biv6t06"]');
      var media = card.querySelector('[class*="e1biv6t05"]');
      var content = card.querySelector('[class*="e1biv6t02"]');
      var title = card.querySelector('[class*="e1biv6t01"]');
      var price = card.querySelector('[class*="e1biv6t00"]');
      var image = media && media.querySelector('img');

      addClasses(cardLink, 'card-product__dialog-link');
      addClasses(media, 'media card-product__media card-product__media-variant-2');
      addClasses(content, 'card-product__content card-product__content-variant-2');
      addClasses(title, 'card-product__title title sm black');
      addClasses(price, 'card-product__price text md medium black');
      addClasses(image, 'is-visible');
      if (card.parentElement) setAttributeIfChanged(card.parentElement, 'data-mk-dialog-product-card-slot', 'true');
      var productGrid = card.parentElement;
      for (var depth = 0; productGrid && productGrid !== container && depth < 6; depth += 1) {
        if (productGrid.querySelectorAll('[data-mk-dialog-product-card="recommendation"]').length > 1) {
          setAttributeIfChanged(productGrid, 'data-mk-dialog-product-card-grid', 'true');
          break;
        }
        productGrid = productGrid.parentElement;
      }
      enrichRecommendationCard(card, title, content);
    });
  }

  function customize(mode) {
    var panel = getPanel();
    if (!panel) return false;
    if (activeMode === 'native-diagnostic' || mode === 'native-diagnostic') return false;
    activeMode = mode || activeMode;

    markPanelShell(panel);
    syncSingleLogo(panel);
    updateTopControls(panel);

    if (mode !== 'diagnostic' && document.documentElement.classList.contains('mk-dialog-diagnostic-opening')) {
      return false;
    }

    if (!isPanelHydrated(panel, mode)) {
      return false;
    }

    try {
      syncSingleLogo(panel);
      if (mode === 'diagnostic') {
        panel.removeAttribute('data-mk-dialog-chat-input-visible');
        updateAssistantTitles(panel);
        styleTextNodes(panel);
        styleButtons(panel);
        addPlanityChoice(panel);
        enhanceDiagnosticChoices(panel);
      } else {
        if (mode !== 'chat') panel.removeAttribute('data-mk-dialog-chat-input-visible');
        resetDiagnosticCustomization(panel);
        markChatMessages(panel);
        markChatInput(panel);
        markRecommendationCards(panel);
      }
      hidePoweredBy(panel);
      setAttributeIfChanged(panel, 'data-mk-dialog-enhanced', mode || 'default');
      return true;
    } catch (error) {
      return false;
    }
  }

  function scheduleCustomize(mode, reason) {
    if (customizeQueued && mode !== 'diagnostic') return;
    customizeQueued = true;

    [160, 360, 700, 1200, 2000].forEach(function (delay) {
      window.setTimeout(function () {
        customizeQueued = false;
        customize(mode);
      }, delay);
    });

  }

  function scheduleLoadingChrome(reason) {
    [40, 100, 180, 320, 600, 1000].forEach(function (delay) {
      window.setTimeout(function () {
        if (activeMode === 'native-diagnostic') return;
        var panel = getPanel();
        if (!panel) return;
        syncSingleLogo(panel);
        updateTopControls(panel);
      }, delay);
    });
  }

  function ensureNativePlanityChoice() {
    if (activeMode !== 'native-diagnostic') return false;
    var panel = getPanel();
    var referenceButton = panel && findWithoutPhotoButton(panel);
    if (!panel || !referenceButton) return false;
    if (panel.querySelector('[data-mk-planity-choice]')) return true;

    var button = createNativePlanityChoice(referenceButton);
    if (!button) return false;
    referenceButton.insertAdjacentElement('afterend', button);
    return true;
  }

  function runNativeDiagnosticEnhancement() {
    if (activeMode !== 'native-diagnostic') return;
    var panel = getPanel();
    if (!panel) return;
    ensureNativePlanityChoice();
    var input = panel.querySelector('#dialog-ai-input');
    if (input && !input.disabled) {
      markChatInput(panel, true);
    } else {
      panel.removeAttribute('data-mk-dialog-chat-input-visible');
    }
    markRecommendationCards(panel);
    hidePoweredBy(panel);
  }

  function scheduleNativeDiagnosticEnhancement() {
    [0, 16, 40, 80, 140, 240, 420, 800, 1400].forEach(function (delay) {
      window.setTimeout(function () {
        runNativeDiagnosticEnhancement();
      }, delay);
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mk-planity-choice]')) {
      event.preventDefault();
      window.location.href = PLANITY_URL;
      return;
    }

    if (activeMode === 'native-diagnostic' && event.target.closest('#dialog-ai-chat-panel button[aria-label="Fermer"]')) {
      activeMode = 'default';
      document.documentElement.classList.remove('mk-dialog-diagnostic-custom');
      return;
    }

    if (event.target.closest('[data-dialog-diagnostic-trigger], #dialog-diagnostic-button, .dialog-instant .dialog-diagnostic')) {
      activeMode = 'native-diagnostic';
      document.documentElement.classList.remove('mk-dialog-diagnostic-opening', 'mk-dialog-diagnostic-enhanced');
      document.documentElement.classList.add('mk-dialog-diagnostic-custom');
      scheduleNativeDiagnosticEnhancement();
      return;
    }

    if (event.target.closest('.dialog-instant .dialog-suggestion, .dialog-instant .dialog-input-submit')) {
      activeMode = 'chat';
      document.documentElement.classList.remove('mk-dialog-diagnostic-custom');
      scheduleLoadingChrome('chat-click');
      scheduleCustomize('chat', 'chat-click');
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.dialog-instant form');
    if (!form || !form.querySelector('input, textarea')) return;
    activeMode = 'chat';
    document.documentElement.classList.remove('mk-dialog-diagnostic-custom');
    scheduleLoadingChrome('chat-submit');
    scheduleCustomize('chat', 'chat-submit');
  }, true);

  panelObserver = new MutationObserver(function (mutations) {
    var panel = getPanel();
    if (!panel) return;

    if (activeMode === 'native-diagnostic') {
      var hasRelevantDiagnosticNode = mutations.some(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.target &&
          mutation.target.nodeType === 1 &&
          (
            mutation.target.matches('#dialog-ai-input, form, button') ||
            Boolean(mutation.target.closest && mutation.target.closest('#dialog-ai-chat-panel'))
          )
        ) {
          return true;
        }

        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          return node.matches('[class*="e1biv6t07"], a[href*="askdialog.com"], button') || Boolean(
            node.querySelector('[class*="e1biv6t07"], a[href*="askdialog.com"], button, #dialog-ai-input, form')
          );
        });
      });
      if (!hasRelevantDiagnosticNode) return;
      if (panelRefreshQueued) return;
      panelRefreshQueued = true;
      window.requestAnimationFrame(function () {
        panelRefreshQueued = false;
        runNativeDiagnosticEnhancement();
      });
      return;
    }

    var hasAddedElement = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1;
      });
    });
    if (!hasAddedElement) return;

    var hasNativeLogo = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return false;
        return node.matches('svg[viewBox="0 0 32 31"]') || Boolean(node.querySelector('svg[viewBox="0 0 32 31"]'));
      });
    });

    if (hasNativeLogo) syncSingleLogo(panel);

    if (!panelRefreshQueued && !document.documentElement.classList.contains('mk-dialog-diagnostic-opening')) {
      panelRefreshQueued = true;
      window.requestAnimationFrame(function () {
        panelRefreshQueued = false;
        customize(activeMode === 'diagnostic' ? 'diagnostic' : 'chat');
      });
    }
  });
  panelObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['disabled', 'class', 'style', 'data-state', 'aria-disabled'],
    childList: true,
    subtree: true
  });

  scheduleCustomize('default', 'script-loaded');
})();
